import { render, staticRenderFns } from "./ShelfWidget.vue?vue&type=template&id=6e5f3b83&scoped=true&"
import script from "./ShelfWidget.vue?vue&type=script&lang=js&"
export * from "./ShelfWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShelfWidget.vue?vue&type=style&index=0&id=6e5f3b83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f3b83",
  null
  
)

export default component.exports